import { render, staticRenderFns } from "./DefaultTopbar.vue?vue&type=template&id=877758c4&"
import script from "./DefaultTopbar.vue?vue&type=script&lang=ts&"
export * from "./DefaultTopbar.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultTopbar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports